import $ from 'jquery';
import UI from 'root/ui';
import Cache from 'root/cache';
import Constants from 'root/constants';
import Form from 'root/module/form';
import View from 'view/base';
import Modal from 'root/module/modal';
import Modals from 'root/modals';
import View_Workspace_Invite_Link from 'view/workspace/invite_link';
import Project_Access_Select from 'view/project/access_select';

var Invite_User = View.extend({
    className: 'invite-user-modal',

    views: {
        workspace_invite_link: {},
        project_access_select: {}
    },

    events: {
        'click .invite-type' : 'onChooseInviteType',
        'click .box-setting' : 'onChooseRole',
        'click .upgrade'     : 'upgrade',
        'submit form'        : 'onSubmit'
    },

    dom_handlers: {
        onChooseInviteType: function(e) {
            var invite_type = $(e.currentTarget).data('val');

            $(e.currentTarget).addClass('active').siblings().removeClass('active');

            if (invite_type === 'link') {
                this.$el.find('.region-invite-form').hide();
                this.$el.find('.region-invite-link').show();
            } else {
                this.$el.find('.region-invite-form').show();
                this.$el.find('.region-invite-link').hide();
            }
        },

        onChooseRole: function(e) {
            if ($(e.currentTarget).hasClass('box-setting-disabled')) {
                Modals.unlockFeature(false, 'Let\'s Go!');

                return;
            }

            this.$el.find('.box-setting').removeClass('active');
            this.$el.find('.box-setting i.fa-check').remove();

            $(e.currentTarget).addClass('active');
            $(e.currentTarget).prepend('<i class="far fa-check"></i>');

            if (this.showProjectSelect()) {
                var role = parseInt($(e.currentTarget).data('role'), 10);
                this.$el.find('.project-access-options').toggle(role !== Constants.ADMIN);
            }
        },

        upgrade: function(e) {
            e.preventDefault();

            Modals.choosePlan();
        },

        onSubmit: function(e) {
            e.preventDefault();

            var emails = [];
            var valid  = true;

            var emails_input = this.$el.find('input[name="emails"]');
            var textarea_val = emails_input.val().trim();

            $(textarea_val.split(/[(,)( )(\r\n)(\r)(\n)]+/)).each(function(index, email) {
                email = email.trim();
                if (email.match(/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/) && !email.match(/qq\.com/) && !email.match(/163\.com/)) {
                    emails.push(email);
                } else {
                    emails_input.get(0).selectionStart = textarea_val.indexOf(email);
                    emails_input.get(0).selectionEnd   = textarea_val.indexOf(email) + email.length;
                    emails_input.focus();

                    valid = false;
                    return false;
                }
            });

            if (!valid || !emails.length) {
                return;
            }

            var role        = parseInt(this.$el.find('.box-setting').filter('.active').data('role'), 10);
            var project_ids = Form.getData(this.$el.find('form'), 'project_ids');

            if (this.showProjectSelect() && role !== Constants.ADMIN && !project_ids) {
                UI.error('Please choose a project.');
                return;
            }

            var user_limit = Cache.account.getUserLimit()
            var user_count = Cache.workspace_member.where({is_disabled: false}).length;
            var invitation_count = Cache.user_invitation.length;
            var extra_seats_needed = user_count + invitation_count + emails.length - user_limit;
            var seat_remaining = Math.max(0, user_limit - user_count - invitation_count);
            var confirm_text = 'Yes, send invitation' + (emails.length === 1 ? '' : 's');

            if (user_count + invitation_count + emails.length > Cache.account.getUserMax()) {
                Modals.unlockFeature('You can have up to ' + Cache.account.getUserMax() + ' seats in your plan. Upgrade your plan to invite more team members.', 'Upgrade Plan');
                return;
            }

            if (extra_seats_needed > 0) {
                Modal.open({
                    title: 'Confirm',
                    content: '<p><b>Inviting ' + emails.length + ' new team member' + (emails.length === 1 ? '' : 's') + '</b><div class="box-medium">' + seat_remaining + ' seat' + (seat_remaining === 1 ? '' : 's') + ' remaining - <b>$' + Cache.account.getExtraUserPrice(Cache.account.get('plan'), 1, Cache.account.get('billing_interval')) + '/mo</b> per additional seat</div></p>',
                    button: {
                        [confirm_text]: () => {
                            Modal.close();
                            this.$el.find('form button[type="submit"]').addClass('loading').prop('disabled', true);

                            // 1. change plan
                            Cache.app.request({
                                action: 'account/changePlan',
                                data: {
                                    billing_interval : Cache.account.get('billing_interval'),
                                    plan             : Cache.account.get('plan'),
                                    extra_user       : Cache.account.get('extra_user') + extra_seats_needed,
                                    has_portal       : Cache.account.hasAddon('portal')
                                },
                                success: (response) => {
                                    if (response && response.success === true) {
                                        Cache.app.trackEvent('Buy Seats', {
                                            seats: extra_seats_needed
                                        });

                                        // 2. send invite
                                        this.sendInvite(emails, role, project_ids, true);
                                    } else {
                                        UI.error('Unexpected error occurred. Please try again later.');
                                    }
                                }
                            });
                        }
                    },
                    text_link: {
                        'Manage seats for my plan': (e) => {
                            Modals.choosePlan(undefined, undefined, true);
                        }
                    },
                    text_link_class: 'primary font-weight-medium'
                });
            } else {
                this.sendInvite(emails, role, project_ids);
            }
        }
    },

    initialize: function() {
        this.views.workspace_invite_link = new View_Workspace_Invite_Link({model: Cache.getDefaultWorkspace()});
        this.views.project_access_select = new Project_Access_Select();
    },

    sendInvite: function(emails, role, project_ids, refresh) {
        var button = this.$el.find('form button[type="submit"]');
        button.addClass('loading').prop('disabled', true);

        Cache.app.request({
            action: 'account/inviteUser',
            data: {
                emails: emails,
                project_ids: project_ids || '',
                role: role
            },
            success: (response) => {
                if (refresh) {
                    window.location.href = '/member/?msg=invitation' + (emails.length === 1 ? '' : 's') + ' sent';
                } else {
                    var models_to_remove = [];
                    Cache.user_invitation.each(function(model) {
                        if (emails.indexOf(model.get('email')) !== -1) {
                            models_to_remove.push(model);
                        }
                    });

                    // remove existing invitations
                    Cache.user_invitation.remove(models_to_remove);

                    // add new invitations
                    Cache.user_invitation.add(response);

                    // getting started page 'add members to workspace'
                    Cache.app.trackOnboarding('workspace_members_add', '1');

                    Cache.app.trackEvent('Member Created');

                    UI.success(emails.length + ' invitation' + (emails.length === 1 ? '' : 's') + ' sent');

                    this.trigger('submit_success');

                }
            },
            complete: () => {
                button.removeClass('loading').prop('disabled', false);
            }
        });
    },

    showProjectSelect: function() {
        if (Cache.account.hasFeature('user_restriction') && Cache.project.where({is_archived: false}).length) {
            return true;
        } else {
            return false;
        }
    },

    render: function() {
        var has_client_role = Cache.account.hasFeature('client_role');

        var content =
        '<div class="badge-group-tertiary">' +
            '<span class="invite-type active" data-val="email">Invite via email</span>' +
            '<span class="invite-type" data-val="link">Share invite link</span>' +
        '</div>' +

        '<div class="divider-32"></div>' +

        '<form class="region-invite-form form-fluid">' +
            '<div class="row">' +
                '<div class="field-label">Send invitation to:</div>' +
                '<input type="text" class="solid medium" name="emails" placeholder="recipient1@example.com, recipient2@example.com" required autofocus></textarea>' +
            '</div>' +
            '<div class="row">' +
                '<div class="field-label">Member Role:</div>' +
                '<div class="box-setting margin-bottom-5" data-role="' + Constants.ADMIN + '">' +
                    '<h4>Administrator</h4>' +
                    '<div class="info">Manage account settings, workspaces and billing</div>' +
                '</div>' +
                '<div class="box-setting active margin-bottom-5" data-role="' + Constants.ASSIGNEE + '">' +
                    '<i class="far fa-check"></i>' +
                    '<h4>Collaborator</h4>' +
                    '<div class="info">Manage feedback and survey responses for one or more projects</div>' +
                '</div>' +
                '<div class="box-setting' + (has_client_role ? '' : ' box-setting-disabled')  + '" data-role="' + Constants.CLIENT + '">' +
                    (has_client_role ? '' : '<i class="fas fa-lock-alt text-warning"></i>' ) +
                    '<div class="desc">' +
                        '<h4>Guest</h4>' +
                        '<div class="info">View feedback and survey responses and track their feedback</div>' +
                    '</div>' +
                '</div>' +
            '</div>' +
            '<div class="row project-access-options">' +
                '<div class="field-label">Choose projects:</div>' +
                '<div class="info margin-bottom-10">The invited user will have access to the selected projects</div>' +
                '<div class="project-access-select-region"></div>' +
                '<hr>' +
            '</div>' +
            '<div class="text-align-center">' +
                '<button type="submit" class="primary">Send Invitation</button>' +
            '</div>' +
        '</form>' +

        '<div class="region-invite-link" style="display:none;"></div>';

        this.$el.html(content);

        if (this.showProjectSelect()) {
            this.views.project_access_select.render().$el.appendTo(this.$el.find('.project-access-select-region'));
        } else {
            this.$el.find('.project-access-options').hide();
        }

        this.views.workspace_invite_link.render().$el.appendTo(this.$el.find('.region-invite-link'));

        return this;
    }
});

export default Invite_User;
